export default __webpack_public_path__ + "7a03bf238ea55fec25927e9f4bc93795.png";